import React, { useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { BiHide, BiShow } from "react-icons/bi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const DatasourceAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    code: '',
    name: '',
    nameLang2: '',
    nameLang3: '',
    description: '',
    vendor: '',
    product: '',
    apiName: '',
    apiType: '',
    apiVersion: '',
    apiBaseurl: '',
    apiKey: '',
    apiSecret: '',
    config: '{}',
    info: '',
    proxyService: ''
  });

  // UI Functions

  const [maskApiSecret, setMaskApiSecret] = useState(true);
  const inputRef = useRef(null);

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const handleCreateCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }

  const handleCreateSubmit = (e) => {
    e.preventDefault();

    setErrMsg('');

    // Validate form inputs
    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (objAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 50);
      return;

    } else if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name && objAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
      return;

    } else if (objAttrs.nameLang2 && (objAttrs.nameLang2.length > 100)) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (objAttrs.nameLang3 && (objAttrs.nameLang3.length > 100)) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (!objAttrs.description || objAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    } else if (objAttrs.name && objAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
      return;

    } else if (objAttrs.vendor.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_vendor") + 20);
      return;

    } else if (objAttrs.product.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_product") + 50);
      return;

    } else if (objAttrs.apiName.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_api_name") + 50);
      return;

    } else if (objAttrs.apiType && objAttrs.apiType.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_api_type") + 50);
      return;

    } else if (objAttrs.apiVersion.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_api_version") + 50);
      return;

    } else if (objAttrs.apiBaseurl.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_api_baseurl") + 100);
      return;

    } else if (objAttrs.apiKey.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_api_key") + 200);
      return;

    } else if (objAttrs.apiSecret.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_api_secret") + 200);
      return;

    } else if (objAttrs.info.length > 1000) {
      setErrMsg(t("I18N_ERR_Max_len_info") + 1000);
      return;

    } else if (objAttrs.proxyService.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_proxy_service") + 50);
      return;

    } else if (   (objAttrs.config)
               && (objAttrs.config !== '')
               && (!testJSON(objAttrs.config.trim()))) {
      // Validate configuration to be valid JSON
      setErrMsg(t("I18N_ERR_Config_need_valid_JSON"));
      return;
    }

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(objAttrs));

    if ((objAttrs.config == null) || (objAttrs.config === '')) {
      reqBody.config = null;
    } else {
      reqBody.config = JSON.parse(objAttrs.config.trim());
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("datasources/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  const handleToggleMask = (e) => {
    e.preventDefault();
    setMaskApiSecret(!maskApiSecret);

    // Use setTimeout to allow React to re-render the input with the new type
    // before trying to focus it, which ensures the cursor position is maintained.
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        // Optional: place the cursor at the end of the input value
        inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
      }
    }, 0);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Datasource")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Datasource_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label}>
                <Col sm={3}>{t("I18N_Datasource_code")}: *</Col>
                <Col sm={3}>{t("I18N_Name")}: *</Col>
                <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
                <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={objAttrs.code}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={objAttrs.name}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang2" value={objAttrs.nameLang2}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang3" value={objAttrs.nameLang3}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_Description")}: *</Col>
                <Col sm={3}>{t("I18N_Vendor")}:</Col>
                <Col sm={3}>{t("I18N_Product")}:</Col>
                <Col sm={3}>{t("I18N_Proxy_service")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3}>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                            name="description" value={objAttrs.description}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="vendor" value={objAttrs.vendor}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="product" value={objAttrs.product}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="proxyService" value={objAttrs.proxyService}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_API_name")}:</Col>
                <Col sm={3}>{t("I18N_API_type")}:</Col>
                <Col sm={3}>{t("I18N_API_version")}:</Col>
                <Col sm={3}>{t("I18N_API_baseurl")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="apiName" value={objAttrs.apiName}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="apiType" value={objAttrs.apiType}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="apiVersion" value={objAttrs.apiVersion}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="apiBaseurl" value={objAttrs.apiBaseurl}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={6}>{t("I18N_API_key")}:</Col>
                <Col sm={6}>
                  <span>{t("I18N_API_secret")}:</span>
                  <span onClick={handleToggleMask} style={{ cursor:'pointer', color:'rgb(100,100,100)', marginLeft:'10px'}}>
                    { maskApiSecret ?
                      <BiHide size={16} />
                    :
                      <BiShow size={16} />
                    }
                  </span>
                </Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={6}>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'50', backgroundColor:'white'}}
                            name="apiKey" value={objAttrs.apiKey}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={6}>
                  <textarea className={classes.admin_pages__field_editable}
                            style={{WebkitTextSecurity: maskApiSecret ? 'disc' : 'none', minWidth: '100%', minHeight:'50', backgroundColor:'white'}}
                            name="apiSecret" value={objAttrs.apiSecret}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={6}>{t("I18N_Config")}:</Col>
                <Col sm={6}>{t("I18N_Info")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={6}>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                            name="config" value={objAttrs.config}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col sm={6}>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                            name="info" value={objAttrs.info}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                <span>{t("I18N_Req_fields")}</span>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={handleCreateCancel}>
                    {t("I18N_Cancel")}
                  </Button>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ marginLeft: '15px' }}
                    onClick={handleCreateSubmit}>
                    {t("I18N_Save")}
                  </Button>
                  <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg}
                  </span>
                </div>
              </Row>
            </form>
          </Container>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {updateObjErrMsg}
            </span>
*/}
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default DatasourceAdminNewView;
